import Box from '@mui/material/Box';
import Portal from '@mui/material/Portal';
import { CircularProgress } from '@mui/material';

// ----------------------------------------------------------------------

export function LoadingSpinner({ portal, sx, ...other }) {
  const content = (
    <Box
      sx={{
        px: 5,
        width: 1,
        flexGrow: 1,
        // minHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
      {...other}
    >
      <CircularProgress color="inherit" />
    </Box>
  );

  if (portal) {
    return <Portal>{content}</Portal>;
  }

  return content;
}
